import { useTranslation } from 'react-i18next';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { StatsIcon } from '../../../../../components/icons/stats-icon';
import { ConsumptionTrendAverageGraph } from '../../../../../components/graphs/consumption-trend-average';
import { useGetEosConsumptionVsAverageQuery } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { useMemo } from 'react';
import { NoDataWidgetContent } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { utcToZone } from '../../../../../utils/date/utcToZone';

export function ConsumptionTrendAverageWidget() {
  const { t: tWidget } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();

  const { data, isLoading, isError } = useGetEosConsumptionVsAverageQuery(
    {
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );
  const { resolution } = data ?? {};

  const mappedData = useMemo(() => {
    if (!data?.buckets || data.buckets.length === 0) return [];
    return data.buckets.map(({ key, ...item }) => ({
      key: utcToZone(key),
      color: '#14B8A6',
      ...item,
    }));
  }, [data]);

  return (
    <DashboardCardWrapper
      to="/reporting/consumption-energy"
      icon={<StatsIcon />}
      title={tWidget('consumptionAverageTrend.title')}
      loading={isLoading}
    >
      {(!isLoading || isError) && mappedData.length === 0 ? (
        <NoDataWidgetContent noDataText={tWidget('energy.noData')} />
      ) : (
        <div className="h-[14em] lg:min-h-auto">
          <ConsumptionTrendAverageGraph data={mappedData} resolution={resolution!} />
        </div>
      )}
    </DashboardCardWrapper>
  );
}
